import { render, staticRenderFns } from "./TvModelWinEdit.vue?vue&type=template&id=4d9a1465&scoped=true&"
import script from "./TvModelWinEdit.vue?vue&type=script&lang=js&"
export * from "./TvModelWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./TvModelWinEdit.vue?vue&type=style&index=0&id=4d9a1465&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a1465",
  null
  
)

export default component.exports